module.exports = __webpack_public_path__ + "img/gold_vip.d81e55a9.png";